export default "/img/spartan.png"